// ⚠️ GENERATED COPY — DO NOT EDIT.
// Source: shared/ui/journey/ProgressTimeline.tsx — edit there, then run: bash scripts/sync_shared_code.sh
// CI verifies these copies match the source (sync_shared_code.sh --check).
import React from "react";
import { journeyStepStates, type JourneyStep } from "../../lib/journeySteps";
import { J } from "./journeyTheme";

// Lighter than J.muted on purpose: upcoming steps should recede, as approved.
// The prototype's lighter grey read fine at poster size but is ~2.9:1 on the
// paper ground at 10.5px; muted ink keeps the "not yet" feel at 5:1.
const UPCOMING = "#5b6e7c";
const TRANSITION = "background .3s ease, border-color .3s ease";

function Check() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 12l5 5L20 7" />
    </svg>
  );
}

export default function ProgressTimeline(props: {
  steps: JourneyStep[];
  currentKey: string | null;
  doneAll?: boolean;
  style?: React.CSSProperties;
}) {
  const states = journeyStepStates(props.steps, props.currentKey, props.doneAll);
  return (
    <div role="list" style={{ display: "flex", alignItems: "flex-start", ...props.style }}>
      {states.map((s) => {
        const bg = s.done ? J.sage : s.current ? J.ink : J.white;
        const border = s.done ? J.sage : s.current ? J.ink : J.border;
        const fg = s.upcoming ? UPCOMING : J.white;
        // The last step is fixed-width: as a flexible item it clipped its label.
        const flex = s.hasLine ? "1 1 0" : "0 0 60px";
        return (
          <div
            key={s.key}
            role="listitem"
            aria-current={s.current ? "step" : undefined}
            style={{ display: "flex", alignItems: "flex-start", flex, minWidth: 0 }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 5,
                width: 60,
                flex: "0 0 60px",
              }}
            >
              <div
                style={{
                  width: 26,
                  height: 26,
                  boxSizing: "border-box",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: bg,
                  border: `2px solid ${border}`,
                  color: fg,
                  fontSize: 12,
                  fontWeight: 700,
                  transition: TRANSITION,
                }}
              >
                {s.done ? <Check /> : s.number}
              </div>
              <div
                style={{
                  fontSize: 10.5,
                  color: s.upcoming ? UPCOMING : J.ink,
                  whiteSpace: "nowrap",
                  fontWeight: s.current ? 700 : 400,
                }}
              >
                {s.label}
              </div>
            </div>
            {s.hasLine && (
              <div
                aria-hidden="true"
                style={{
                  flex: "1 1 0",
                  height: 3,
                  borderRadius: 2,
                  background: s.done ? J.sage : J.line,
                  margin: "12px 0 0",
                  transition: "background .3s ease",
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
